
// import React, { useEffect, useState } from 'react'
// import axios from 'axios'
// import { Link } from 'react-router-dom'
// import socket from '../Components/socket'
// import '../css/landing.css'
// import Rightcontainer from '../Components/Rightcontainer'
// import Downloadbutton from '../Components/Downloadbutton'
// import Header from '../Components/Header'
// import { HiDownload } from "react-icons/hi";
// import { Carousel } from "react-bootstrap";

// export default function Landing() {
//   const token = localStorage.getItem('token')
//   const [userAllData, setUserAllData] = useState()
//   const [siteSetting, setsiteSetting] = useState([])
//   // console.log(siteSetting,'siteSetting')

//   useEffect(() => {
//     socket.emit('websetting', '')
//   }, [])
//   const fetchUser = async () => {
//     const access_token = localStorage.getItem('token')
//     if (!access_token) return
//     const headers = { Authorization: `Bearer ${access_token}` }
//     try {
//       const res = await axios.get(`https://api.rrludo.in/me`, { headers })
//       setUserAllData(res.data)
//     } catch (e) {
//       if (e.response?.status === 401) {
//         localStorage.removeItem('token')
//       }
//     }
//   }

//   useEffect(() => { fetchUser() }, [])

//   useEffect(() => {
//     const items = JSON.parse(localStorage.getItem('sitSetting'))
//     if (items) setsiteSetting(items)
//   }, [])

//   return (
//     <>
//       <Header user={userAllData} />
//       <div className='leftContainer'>
//         <div className='pt-5 mt-5 Orher_page_main_section'>
//           <div className='landing_main_container'>
//             <div className='leftContainer'>
//               <div className='main-area'>
//                 <Downloadbutton />
//                 <div className="site_message_main">
//                   <p>{siteSetting?.homeMsg}</p>
//                 </div>
//               {token && userAllData?.verified === "unverified" && (
//                   <div className="kyc_button_wrapper">
//                     <Link to="/profile" className="kyc_button">
//                       ⚠️ Complete Your KYC
//                     </Link>
//                   </div>
//                 )}

//                 <section className='new_game_section'>

//                   <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
//                     <h6 className="tour_heading">Our Tournaments</h6>
//                   </div>
//                   <div className='row games-row'>
//                     <div className='col-6 col-md-4'>
//                       <Link className='gameCard-container' to={`Homepage/ludoClassicManual`}>
//                         <div className='blinking_text'>◉ LIVE</div>
//                         <div className='game_small_boxes'>

//                           <img src='/images/ludo-classic.png' alt='Ludo Classic' />
//                         </div>
//                       </Link>
//                     </div>
//                     {/* <div className='col-6 col-md-4'>
//                       <Link className='gameCard-container' to={``}>
//                         <div className='blinking_text'>◉ Coming soon</div>
//                         <div className='game_small_boxes'>

//                           <img src='/images/LandingPage_img/ludo-1-goti.png' alt='Ludo Classic' />
//                         </div>
//                       </Link>
//                     </div> */}


//                     <div className='col-6 col-md-4 mx-auto'>
//                       <a
//                         className='gameCard-container disabled-game'
//                         href={`https://wa.me/${siteSetting?.whatsappSupport}`}
//                         // href={`https://t.me/Bajigerludo`}
//                         target="_blank"
//                         rel="noopener noreferrer"
//                       >
//                         <div className='blinking_text'>◉ LIVE</div>
//                         <div className='game_small_boxes'>
//                           <img src='/images/popular.png' alt='Coming Soon' />
//                         </div>
//                       </a>
//                     </div>
//                   </div>
//                 </section>
//               </div>
//             </div>

//             {/* Right Container */}
//             <div className='rightContainer'>
//               <Rightcontainer />
//             </div>
//           </div>
//         </div>
//       </div>
//     </>
//   )
// }
import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Link } from 'react-router-dom'
import socket from '../Components/socket'
import '../css/landing.css'
import Rightcontainer from '../Components/Rightcontainer'
import Downloadbutton from '../Components/Downloadbutton'
import Header from '../Components/Header'
import { HiDownload } from "react-icons/hi";
import { Carousel } from "react-bootstrap";

export default function Landing() {
  const token = localStorage.getItem('token')
  const [userAllData, setUserAllData] = useState()
  const [siteSetting, setsiteSetting] = useState([])

  useEffect(() => {
    socket.emit('websetting', '')
  }, [])

  const fetchUser = async () => {
    const access_token = localStorage.getItem('token')
    if (!access_token) return
    const headers = { Authorization: `Bearer ${access_token}` }
    try {
      const res = await axios.get(`https://api.rrludo.in/me`, { headers })
      setUserAllData(res.data)
    } catch (e) {
      if (e.response?.status === 401) {
        localStorage.removeItem('token')
      }
    }
  }

  useEffect(() => { fetchUser() }, [])

  useEffect(() => {
    const items = JSON.parse(localStorage.getItem('sitSetting'))
    if (items) setsiteSetting(items)
  }, [])

  // --- THEME COLOR OVERRIDES ---
  const styles = {
    mainContainer: {
      background: '#FFFDE7', // Light Yellow Background
      minHeight: '100vh',
      color: '#000'
    },
    siteMessage: {
      background: '#000', // Black Message Box
      color: '#FF9800', // Orange Text
      padding: '10px',
      borderRadius: '8px',
      textAlign: 'center',
      fontWeight: '700',
      fontSize: '14px',
      margin: '15px 0'
    },
    kycBtn: {
      background: '#FF9800', // Orange KYC Button
      color: '#000', // Black Text
      display: 'block',
      textAlign: 'center',
      padding: '12px',
      borderRadius: '10px',
      fontWeight: '800',
      textDecoration: 'none',
      border: '2px solid #000'
    },
    tourHeading: {
      color: '#000',
      fontWeight: '800',
      borderLeft: '4px solid #FF9800',
      paddingLeft: '10px'
    },
    gameCard: {
      // background: '#fff',
      // border: '1px solid #FF9800', // Orange Border
      borderRadius: '15px',
      overflow: 'hidden',
      display: 'block',
      position: 'relative'
    },
    liveBadge: {
      background: '#000', // Black Badge
      color: '#FF9800', // Orange Text
      fontSize: '10px',
      padding: '2px 8px',
      fontWeight: '800',
      position: 'absolute',
      top: '5px',
      left: '5px',
      borderRadius: '4px',
      zIndex: 1
    }
  };

  return (
    <>
      <Header user={userAllData} />
      <div style={styles.mainContainer} className='leftContainer'>
        <div className='pt-5 mt-5 Orher_page_main_section'>
          <div className='landing_main_container'>
            <div className='leftContainer'>
              <div className='main-area'>
                
                <Downloadbutton />

                {/* Site Message with Theme Colors */}
                <div style={styles.siteMessage}>
                  <p className="m-0">{siteSetting?.homeMsg}</p>
                </div>

                {token && userAllData?.verified === "unverified" && (
                  <div className="kyc_button_wrapper">
                    <Link to="/profile" style={styles.kycBtn}>
                      ⚠️ Complete Your KYC
                    </Link>
                  </div>
                )}

                <section className='new_game_section'>
                  <div className="d-flex align-items-center justify-content-between mt-3 mb-2">
                    <h6 style={styles.tourHeading}>Our Tournaments</h6>
                  </div>

                  <div className='row games-row'>
                    {/* Ludo Classic Card */}
                    <div className='col-6 col-md-4'>
                      <Link style={styles.gameCard} to={`Homepage/ludoClassicManual`}>
                        <div style={styles.liveBadge}>◉ LIVE</div>
                        <div className='game_small_boxes'>
                          <img src='/images/ludo-classic.png' alt='Ludo Classic' />
                        </div>
                      </Link>
                    </div>

                    {/* WhatsApp Support Card */}
                    <div className='col-6 col-md-4 mx-auto'>
                      <a
                        style={styles.gameCard}
                        href={`https://wa.me/${siteSetting?.whatsappSupport}`}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <div style={styles.liveBadge}>◉ LIVE</div>
                        <div className='game_small_boxes'>
                          <img src='/images/popular.png' alt='Popular' />
                        </div>
                      </a>
                    </div>
                  </div>
                </section>
              </div>
            </div>

            {/* Right Container */}
            <div className='rightContainer'>
              <Rightcontainer />
            </div>
          </div>
        </div>
      </div>
    </>
  )
}